import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { useSubdomain } from '../../../utils/contexts/UrlProvider'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import IconButton from '../../../packages/kiti/components/actions/IconButton'
import LoginTemplate from '../_template/LoginTemplate'
import ViewSwitcher from './ViewSwitcher'
import { useSessionChecker } from '@btime/react-session'
import { Redirect } from '@reach/router'

const LoginFormInternal = () => {
  const { t } = useTranslation('session')
  const workspace = useSubdomain()
  const [isLoading, setIsLoading] = useState()
  const [isLogged] = useSessionChecker()

  if (isLogged) return <Redirect from="/internal" to="/" noThrow />

  return (
    <LoginTemplate footer={<ViewSwitcher />}>
      <div>
        <Title size="h3">{t('welcome')}</Title>

        <Separator weight={4} />
        <IconButton
          icon={'BsGoogle'}
          fullWidth
          transparent
          justify={'center'}
          buttonTextBold
          loading={isLoading}
          onClick={() => {
            if (isLoading) return
            setIsLoading(true)
            window.location.href = `${process.env.REACT_APP_V2_API_URL}/auth/google?workspace=${workspace}`
          }}
          label={t('loginWithGoogle')}
        />
      </div>
    </LoginTemplate>
  )
}

export default LoginFormInternal
